import { render } from "./richiediPagamentoModal.vue?vue&type=template&id=6b1d4eee&scoped=true&ts=true"
import script from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"
export * from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"

import "./richiediPagamentoModal.vue?vue&type=style&index=0&id=6b1d4eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1d4eee"]])

export default __exports__